// extracted by mini-css-extract-plugin
export default {"rulesSlide":"RulesSlide_rulesSlide__SOWeO","contentSlide":"RulesSlide_contentSlide__IycpZ"};